module.exports = __webpack_public_path__ + "images/grupo_IDTravel.12fa9e19.png";